import { ReadonlyVec2 } from 'gl-matrix';
import { View } from '~/engine/view/View';
import { EventHandlerResult } from '../EventHandlerResult';
import { ModifierKeys } from '../ModifierKeys';
import { Tool } from '../Tool';
import { WindowingAction } from '../actions/WindowingAction';
import { PlaneView } from '~/engine/view/views/PlaneView';

/**
 * {@link WindowingTool} is a {@link Tool} that provides default {@link WindowingAction windowing level change} functionality.\
 * {@link WindowingAction} is bound to mouse left click without any {@link ModifierKeys}.\
 */
export class WindowingTool extends Tool {
    public readonly toolType = 'window';
    public constructor(eventTarget: EventTarget) {
        super();
        this._action = new WindowingAction(eventTarget);
    }

    private readonly _action: WindowingAction;

    public onMousePress(
        button: number,
        modifierKeys: ModifierKeys,
        coordinates: ReadonlyVec2,
        view: View
    ): EventHandlerResult {
        return this._action.onMousePress(
            button,
            modifierKeys,
            coordinates,
            view as PlaneView
        );
    }

    public onMouseMove(
        coordinates: ReadonlyVec2,
        _buttons: number,
        _view: View
    ): EventHandlerResult {
        return this._action.onMouseMove(coordinates);
    }

    public onMouseRelease(
        _button: number,
        _coordinates: ReadonlyVec2,
        _view: View
    ): EventHandlerResult {
        return this._action.onMouseRelease();
    }
}
